const PRODUCTION_API_BASE_URL =
  'https://1visj85h00.execute-api.us-east-1.amazonaws.com/prod';

export function getApiBaseUrl() {
  if (typeof window !== 'undefined' && window.__RETECHSYS_RUNTIME_CONFIG__?.apiBaseUrl) {
    return window.__RETECHSYS_RUNTIME_CONFIG__.apiBaseUrl;
  }
  return process.env.REACT_APP_API_BASE_URL || PRODUCTION_API_BASE_URL;
}
